import { useQuery } from "@tanstack/react-query";

import { IPart } from "../models/Part";
import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { DefaultResponseWithData } from "../models/system";
import { IPartProConversation } from "../models/PartProMessage";

export default function usePartProMessagesListing(
  { part }: { part: IPart },
  componentName = "usePartProMessagesListing"
) {
  const { get } = useApiHelper(apiConfig(componentName));
  const staleTime = 1000 * 60 * 10; // 10 minutes

  const conversations = useQuery({
    queryKey: ["partprolistingmessages", part.id],
    queryFn: () => get<DefaultResponseWithData<IPartProConversation[]>>(`/partpromessaging/itemmessages/${part.id}`),
    staleTime: staleTime,
  });

  return {
    conversations,
  };
}
